export const filterRequestPayloadCER = {
    "originRegion": "NA", // send always
    "carrierCodeList": [], // Carrier ID
    "tariffServiceCodeList": [], // Service
    "originCityStateList": [], // Origin Location name
    "deliveryActualArrivalDatetimeFinalDestTZ": {},
    "shipmentNumList": [],
    "carrierArrivalResponseReceived": [],
    "carrierDepartureResponseReceived": [],
    "carrierArrivalResponseReceivedOnTime": [],
    "carrierDepartureResponseReceivedOnTime": []
}


export const optionalFilterPayloadCER = {
    "carrierCodeList": [], // Carrier ID
    "tariffServiceCodeList": [], // Service
    "originCityStateList": [], // Origin Location name
    "deliveryActualArrivalDatetimeFinalDestTZ": {},
    "shipmentNumList": [],
    "carrierArrivalResponseReceived": [],
    "carrierDepartureResponseReceived": [],
    "carrierArrivalResponseReceivedOnTime": [],
    "carrierDepartureResponseReceivedOnTime": []
}

export const defaultFilterPayloadCER = {
    "originRegion": "NA", // send always
}